import { render, staticRenderFns } from "./FlowChart.vue?vue&type=template&id=852c2aa6&"
import script from "./FlowChart.vue?vue&type=script&lang=js&"
export * from "./FlowChart.vue?vue&type=script&lang=js&"
import style0 from "./index.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports